import React from "react";
import { StyleSheet, Image, View } from "../core";
import { commonStyles } from "../assets/css/commonStyle";
import Touchable from "./TouchableComponent";
import bookmared_active from "../assets/images/bookmared_active.png";
import bookmared_unactive from "../assets/images/bookmared_unactive.png";
export default class Bookmarked extends React.Component {
  render() {
    const { isBookmarked, onToggle, bookedMarkStyle, bookedMarkImgStyle, source } = this.props;
    let imgpath = isBookmarked ? bookmared_active : bookmared_unactive;
      return (
        <Touchable tooltip={'Priority'} style={[commonStyles.flex1, bookedMarkStyle]} onPress={onToggle} disabled = {!!source && source === "bA"}>
          <View>
            <Image resizeMode="contain" style={[styles.bookedMark, bookedMarkImgStyle]} source={imgpath} />
          </View>
        </Touchable>
      );
    }
}

const styles = StyleSheet.create({
  bookedMark: {
    height: 22,
    width: 15,
    marginLeft: 16,
    display: "block",
  },
});
